import r from"./memoize.js";var e=r;var a=function(r){var a=e(r,(function(r){return 500===t.size&&t.clear(),r})),t=a.cache;return a};export{a as default};
//# sourceMappingURL=_memoizeCapped.js.map
